<span *ngIf="showTextValue" class="readonly-view">
  <div *ngIf="showLabel" class="readonly-label">{{ label | translate }}</div>
  <div *ngIf="options && control.value !== null && control.value !== undefined; else empty"
       [value]="getOptionsLabel(control.value)" chipView class="readonly-content"></div>
  <ng-template #empty class="readonly-content">-&#45;&#45;</ng-template>
</span>

<div *ngIf="!showTextValue">
  <label class="label-input" *ngIf="showLabel">
    <span> {{ label | translate }}</span>
    <span *ngIf="checkRequire()" class="p-errors" style="color: red; margin-left: 3px">*</span></label
  >
  <p-dropdown
    (onChange)="emitChange($event)"
    styleClass="w-full"
    *ngIf="!multiSelect"
    [filter]="filter"
    [formControl]="control"
    [placeholder]="placeholder"
    [ngClass]="{ 'ng-invalid ng-dirty': errors, readonly: readonly }"
    [optionDisabled]="optionDisabled"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    [options]="options"
    [readonly]="readonly"
    [resetFilterOnHide]="true"
    [scrollHeight]="scrollHeight"
    [showClear]="!readonly && showClear"
    [tooltip]="tooltip"
    [virtualScroll]="virtualScroll"
    [loading]="inputLoading"
    [placeholder]="placeholder"
    appendTo="body">
    <ng-template let-item pTemplate="item">
      {{ item[optionLabel] | translate }}
    </ng-template>
    <ng-template let-item pTemplate="selectedItem">
      {{ item[optionLabel] | translate }}
    </ng-template>
  </p-dropdown>
  <p-multiSelect
    styleClass="w-full"
    (onChange)="emitChange($event)"
    *ngIf="multiSelect"
    [display]="display"
    [dropdownIcon]="dropdownIcon"
    [filter]="filter"
    [formControl]="control"
    [placeholder]="placeholder"
    [ngClass]="{ 'ng-invalid ng-dirty': errors, readonly: readonly}"
    [optionDisabled]="optionDisabled"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    [options]="options"
    [panelStyleClass]="multiselectPanelClass"
    [readonly]="readonly"
    [scrollHeight]="scrollHeight"
    [tooltip]="tooltip"
    [virtualScroll]="virtualScroll"
    [maxSelectedLabels]="options.length - 1"
    [displaySelectedLabel]="true"
    [loading]="inputLoading"
    [selectedItemsLabel]="'label.all' | translate"
    appendTo="body">
    <ng-template let-item pTemplate="item">
      {{ item[optionLabel] | translate }}
    </ng-template>
    <ng-template let-item pTemplate="selectedItem">
      {{ item[optionLabel] | translate }}
    </ng-template>
    <ng-template let-item pTemplate="selectedItems">
      {{ getValue(control) }}
    </ng-template>
  </p-multiSelect>
  <div class="relative b-errors">
    <ng-container *ngIf="errors">
      <small class="p-error error-msg block fadeinup animation-duration-300">
        <span class="block">{{ displayedErrorMessage }}</span>
      </small>
    </ng-container>
  </div>
</div>
